import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src", "width", "height"]
const _hoisted_2 = { class: "onboarding-notifications__options" }

import { computed, onBeforeMount } from 'vue'

import { getImage, QuestionnaireView } from '@/models/onboarding'
import { NotificationsPage } from '@/models/onboarding.types'

import Layout from '../Layout.vue'
import NotificationsOption from '../NotificationsOption.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Notifications',
  props: {
    view: {}
  },
  setup(__props: any) {

const props = __props

const page = computed(() => {
  return props.view.currentPage as NotificationsPage
})

const image = computed(() => {
  if (!page.value.image) {
    return
  }

  return getImage(page.value.image.src)
})

onBeforeMount(() => {
  // Set all options as marked by default.
  props.view.setCurrentChoice(page.value.options.map((option) => option.title))
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Layout, {
    class: "onboarding-notifications",
    title: page.value.title,
    subtitle: page.value.subtitle
  }, _createSlots({
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(page.value.options, (option) => {
          return (_openBlock(), _createElementBlock("div", {
            key: option.title,
            class: "onboarding-notifications__option"
          }, [
            _createVNode(NotificationsOption, {
              option: option,
              view: __props.view
            }, null, 8, ["option", "view"])
          ]))
        }), 128))
      ])
    ]),
    _: 2
  }, [
    (image.value)
      ? {
          name: "aboveTitle",
          fn: _withCtx(() => [
            _createElementVNode("img", {
              class: "onboarding-notifications__image",
              src: image.value,
              width: page.value.image?.width,
              height: page.value.image?.height,
              alt: ""
            }, null, 8, _hoisted_1)
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["title", "subtitle"]))
}
}

})